<template>
  <RouterView />
  <ToastList />
</template>

<script setup lang="ts">
import ToastList from "@/components/ui/toast/ToastList.vue";
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  min-height: 435px;
  min-width: 1050px;
}
</style>
